import { createFileRoute } from "@tanstack/react-router";
import { protectedRoute } from "@/lib/protectedRoute";
import { TemplateEdit } from "@/pages/TemplateEdit";

export const Route = createFileRoute("/template/$templatePublicId")({
  component: TemplateEdit,
  beforeLoad: () => {
    return protectedRoute({ location: window.location });
  },
});
